<template>
  <div>
    <Breadtabsheader/>
    <div class="h-content">
      <div class="h-piece">
        <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder" ref="form">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="合同编码/名称" prop="billNo" style="width: 25%;">
              <el-input v-model="formInline.contractFuzzyQuery" placeholder="请输入"
                        style="width: 100%" />
            </el-form-item>
            <el-form-item label="产品编码/名称" prop="billNo" style="width: 25%;">
              <el-input v-model="formInline.productFuzzyQuery" placeholder="请输入"
                        style="width: 100%" />
            </el-form-item>
            <el-form-item label="调价时间" prop="billNo" style="width: 28%;">
              <el-date-picker
                  style="width: 100%"
                  v-model="valueTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="changeTime"
              />
<!--              <el-date-picker-->
<!--                  v-model="formInline.cdateStart"-->
<!--                  clearable-->
<!--                  type="date"-->
<!--                  value-format="yyyy-MM-dd" >-->
<!--              </el-date-picker>-->
<!--              <span class="w-time-to">至</span>-->
<!--              <el-date-picker-->
<!--                  v-model="formInline.cdateEnd"-->
<!--                  clearable-->
<!--                  type="date"-->
<!--                  value-format="yyyy-MM-dd" >-->
<!--              </el-date-picker>-->
            </el-form-item>
            <el-form-item label="供应商编码/名称" prop="billNo" style="width: 25%;">
              <el-input v-model="formInline.customerFuzzyQuery" placeholder="请输入"
                        style="width: 100%" />
            </el-form-item>
          </div>
<!--          <div class="h-thirdColumn w-newColumn">-->
<!--            <el-form-item label="供应商编码/名称" prop="billNo" style="width: 25%;">-->
<!--              <el-input v-model="formInline.customerFuzzyQuery" placeholder="请输入"-->
<!--                        style="width: 100%" />-->
<!--            </el-form-item>-->
<!--          </div>-->
        </el-form>
        <div class="l-screenBox">
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
          </div>
        </div>
      </div>
      <!--数据展示-->
      <div class="h-table h-mrt30">
        <el-table
            :data="tableData"
            ref="multipleTable"
            :border="true"
            style="width: 100%"
            max-height="450"
        >
          <el-table-column
              label="合同编号"
              prop="ccode"
              width="120"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="合同名称"
              prop="contractName"
              width="120"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="供应商编码"
              prop="customerCode"
              width="100"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="供应商名称"
              prop="customerName"
              width="200"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="产品编码"
              prop="productId"
              width="100"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="产品名称"
              prop="productName"
              width="140"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="税率"
              prop="shuilv"
              width="60"
              show-overflow-tooltip>
            <template slot-scope="scope">
              <dictname category="cgshuilv"  :v="scope.row.shuilv"/>
            </template>
          </el-table-column>
          <el-table-column
              label="原价格"
              prop="oldUnitPrice"
              width="100"
              show-overflow-tooltip>
            <template slot-scope="scope">
              {{ cleanNumber(scope.row.oldUnitPrice).toString() }}
            </template>
          </el-table-column>
          <el-table-column
              label="调整后价格"
              prop="unitPrice"
              width="100"
              show-overflow-tooltip>
            <template slot-scope="scope">
              {{ cleanNumber(scope.row.unitPrice).toString() }}
            </template>
          </el-table-column>
          <el-table-column
              label="价差"
              prop="priceSpread"
              width="100"
              show-overflow-tooltip>
            <template slot-scope="scope">
              {{ calculatePriceDiff(scope.row.unitPrice, scope.row.oldUnitPrice) }}
            </template>
          </el-table-column>
          <el-table-column
              label="调价人"
              prop="cuname"
              width="70"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="调价时间"
              prop="cdate"
              width="140"
              show-overflow-tooltip>
          </el-table-column>
          <el-table-column
              label="审核通过时间"
              prop="approvalTime"
              width="140"
              show-overflow-tooltip>
          </el-table-column>
        </el-table>
<!--        <div class="h-tableBL">-->
<!--          <el-button type="primary" @click="exportExcel">批量导出</el-button>-->
<!--        </div>-->
        <div class="h-pagination2">
          <pagination :page="formInline" @query="query"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import reduceCost from "@/api/invoice/reduceCost";
export default {
  data() {
    return {
      formInline:{
        contractFuzzyQuery: '',
        productFuzzyQuery: '',
        customerFuzzyQuery: '',
        cdateStart: '',
        cdateEnd: '',
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      valueTime: 0,
      tableData: []
    }
  },
  methods:{
    // 清洗单个数值：统一格式为“最多2位小数，无小数显整数”
    cleanNumber(value) {
      // 步骤1：处理空值/非数值（如null/undefined/""，默认按0处理）
      if (value === null || value === undefined || value === "") {
        return 0;
      }
      // 步骤2：转为数字类型（处理字符串格式的数值，如"10.00"→10.00）
      const num = Number(value);
      // 步骤3：确保是有效数字（避免NaN，无效数字按0处理）
      if (isNaN(num)) {
        return 0;
      }
      // 步骤4：保留2位小数→转数字（去末尾0）→返回处理后的值（数字类型）
      return Number(num.toFixed(2));
    },

    // 计算价格差值并格式化最终结果
    calculatePriceDiff(unitPrice, oldUnitPrice) {
      // 步骤1：分别清洗两个参数（确保格式统一）
      const cleanedUnitPrice = this.cleanNumber(unitPrice);
      const cleanedOldUnitPrice = this.cleanNumber(oldUnitPrice);

      // 步骤2：计算差值（处理浮点数精度问题）
      const diff = (cleanedUnitPrice * 100 - cleanedOldUnitPrice * 100) / 100;

      // 步骤3：格式化差值（最多2位小数，不补0）
      return Number(diff.toFixed(2)).toString();
    },
    changeTime(date){
      if(date){
        this.formInline.cdateStart = date[0];
        this.formInline.cdateEnd = date[1];
      }else{
        this.formInline.cdateStart = '';
        this.formInline.cdateEnd = '';
      }
    },
    handleFilter(){
      this.formInline.pageNo = 1
      this.query()
    },
    resetData(){
      this.formInline = {
        contractFuzzyQuery: '',
        productFuzzyQuery: '',
        customerFuzzyQuery: '',
        cdateStart: '',
        cdateEnd: '',
        pageNo: 1,
        pageSize: 10,
        total: 0
      }
      this.valueTime = []
      this.query()
    },
    query(){
      reduceCost.selectCgShenpiPage(this.formInline).then(res => {
        this.tableData = res.records;
        this.formInline.total = res.total;
      })
    },
    // exportExcel(){
    //
    // }
  },
  created() {
    this.query();
  },
  activated() {
    this.query()
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-date-editor .el-range-separator{
  padding: 0px 20px 0px 6px;
}
</style>